<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>
<style lang="scss" src="./group.scss"></style>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex'
  import { isMobile } from 'mobile-device-detect'
  import EditGroupOverlay from '@/components/overlays/group/EditGroupOverlay'
  import GroupInfo from '@/components/modules/group/GroupInfo'
  import GroupTopics from '@/components/modules/group/GroupTopics'
  import ManageMembersOverlay from '@/components/overlays/group/ManageMembersOverlay'
  import TopicFormOverlay from '@/components/overlays/group/TopicFormOverlay'
  import GroupFiles from '@/components/modules/group/GroupFiles'
  import GroupMembers from '@/components/modules/group/GroupMembers'
  import ConfirmationOverlay from '@/components/overlays/ConfirmationOverlay'
  import CreatePost from '@/components/modules/CreatePost'

  export default {
    name: 'GroupPage',
    metaInfo() {
      return {
        title: this.$t('meta.group.title', { name: this.title }),
      }
    },
    components: {
      ConfirmationOverlay,
      CreatePost,
      GroupFiles,
      GroupMembers,
      NewsStream: () => import('@/components/modules/NewsStream'),
      EditGroupOverlay,
      GroupInfo,
      GroupTopics,
      ManageMembersOverlay,
      TopicFormOverlay,
    },
    data() {
      return {
        groupTabs: null,
        selectedTab: null,
        selectedOverlay: null,
        usersPerPage: 0,
      }
    },
    computed: {
      ...mapState('auth', ['settings']),
      ...mapState('groups', [
        'group',
        'pending',
      ]),
      ...mapGetters('groups', [
        'canDeleteGroup',
        'canEditGroup',
        'canLeaveGroup',
        'canManageTopic',
        'canPostContent',
      ]),
      getLeaveGroupObject() {
        return {
          title: this.$t('group.overlays.leave_group.title'),
          img: this.group.infos.img,
          text: this.$t('group.overlays.leave_group.text'),
          button_text: this.$t('group.overlays.leave_group.button_text'),
        }
      },
      getDeleteGroupObject() {
        return {
          title: this.$t('group.overlays.delete_group.title'),
          img: this.group.infos.img,
          text: this.$t('group.overlays.delete_group.text'),
          button_text: this.$t('group.overlays.delete_group.button_text'),
        }
      },
      title() {
        return this.group.infos ? this.group.infos.title : ''
      },
    },
    watch: {
      selectedTab: function(val) {
        if (val === 'members') {
          this.clearGroupMembers()
          this.getGroupMembers({ id: this.$route.params.id, options: { page: 1, per_page: this.usersPerPage } })
        }
        if (this.$route.query && this.$route.query.selectedTab !== val) {
          this.$router.replace({ query: { selectedTab: val } })
        }
      },
      '$route.params.id'() {
        this.requestGroup()
      },
    },
    created() {
      this.usersPerPage = isMobile ? 8 : 15
      this.requestGroup()
      if (this.$route.query && this.$route.query.selectedTab) {
        this.selectedTab = this.$route.query.selectedTab
      }
    },
    destroyed() {
      this.clearGroup()
    },
    methods: {
      ...mapActions('groups', [
        'getGroup',
        'clearGroup',
        'clearGroupMembers',
        'leaveGroup',
        'editGroup',
        'deleteGroup',
        'manageMembers',
        'getGroupMembers',
        'checkGroup',
      ]),
      ...mapActions('topics', [
        'createTopic',
        'createTopicSuggestion',
      ]),
      ...mapActions('auth', ['getRoutes']),
      ...mapActions('posts', [ 'getOptionsForGroup' ]),
      requestGroup() {
        this.getGroup(this.$route.params.id).then(status => {
          if (status && status === -1) {
            return false
          }
          this.getOptionsForGroup(this.$route.params.id)
        })
      },
      showMoreMembers() {
        this.getGroupMembers({ id: this.$route.params.id, options: { page: this.group.members.pagination.next, per_page: this.usersPerPage } })
      },
      closeOverlay() {
        this.selectedOverlay = null
      },
      submitTopic(args) {
        const topic = {
          name: args.name,
          description: args.description,
          group_id: this.group.id,
        }
        if (args.type === 'create') {
          this.createTopic(topic).then(_ => {
            this.getGroup(this.$route.params.id)
            this.closeOverlay()
          })
        } else {
          this.createTopicSuggestion(topic).then(_ => this.closeOverlay())
        }
      },
      onEditGroup(description, img_id) {
        this.editGroup({ id: this.$route.params.id, payload: { description, img_id: img_id } }).then(_ => {
          this.closeOverlay()
          this.getGroup(this.$route.params.id)
        })
      },
      onCloseManageOverlay() {
        this.closeOverlay()
        this.getGroup(this.$route.params.id)
      },
      openOverlay(overlay) {
        this.checkGroup(this.$route.params.id).then(status => {
          if (status && status === -1) {
            return false
          }
          this.selectedOverlay = overlay
        })
      },
      actionLeaveGroup() {
        this.leaveGroup(this.group.id).then(_ => this.$router.replace({ name: 'groups' }))
      },
      actionDeleteGroup() {
        this.deleteGroup(this.group.id).then(_ => {
          this.getRoutes()
          this.$router.replace({ name: 'groups' })
        })
      },
    },
  }
</script>
